const COLORS = ["#EF4444", "#3B82F6", "#22C55E", "#F59E0B", "#A855F7"];

export const Logo = ({ text = "DIVINE KIDS LEARNING", className = "" }) => {
  let colorIndex = 0;
  return (
    <span
      data-testid="brand-logo"
      aria-label={text}
      className={`font-display font-black tracking-tight leading-none ${className}`}
    >
      {text.split("").map((ch, i) => {
        if (ch === " ") return <span key={i}>&nbsp;</span>;
        const color = COLORS[colorIndex % COLORS.length];
        colorIndex += 1;
        return (
          <span key={i} style={{ color }}>
            {ch}
          </span>
        );
      })}
    </span>
  );
};
